import React, { Component, CSSProperties, Dispatch } from 'react';
import { EAddActivityType } from '../../models/components/add-activity';
import { connect } from 'react-redux';
import { any, bool, number } from 'prop-types';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../models/action/core';
import * as Action from '../../store/actions/core';
import CAddAssignment from './header-options/add-activity-assignment-modal/main';
import CAddDocument from './header-options/add-activity-document-modal/main';
import CAddProject from './header-options/add-activity-project-modal/main';
import CAddSurvey from './header-options/add-activity-survey-modal/main';
import CAddElesson from './header-options/add-activity-elesson-modal/main';
import CAddVirtualClass from './header-options/add-activity-virtualClass-modal/main';
import CAddLink from './header-options/add-activity-link-modal/main';
import CAddVideo from './header-options/add-acitivty-video-modal/main';
import { IHeaderOptions } from '../../models/components/header-options';
import * as Actions from '../../store/actions/login';
import * as CourseActions from '../../store/actions/coursePage';
import * as AnnouncementAction from '../../store/actions/announcement';
import * as ProfileAction from '../../store/actions/profile';
import * as NotificationPageAction from '../../store/actions/notification';
import { UserType } from '../../models/pages/login.d';
import { withRouter } from 'react-router-dom';
import Translator from '../../core/i18n';
import { Common } from '../../core/common';
import { SecureImage } from '../../components/core/secureImage';
import { ActivityType, ActivityTypeEnums } from '../../models/enums/ActivityType';
import { NotificationTypes } from '../../models/enums/NotificationTypes';
import CAddForum from './header-options/add-activity-forum-modal/main';
import { Notification } from '../../components/notification/main';
import BaseModal from '../../modal/base-modal/main';
import LoginAnnouncementModal from '../../modal/in-modal/login-announcement/main';
import CAddExam from './header-options/add-activity-exam-modal/main';
import CAddLTI from './header-options/add-activity-lti-modal/main';
import { Modal } from 'reactstrap';
import { CourseContentMenuType } from '../../models/enums/CourseContentMenuType';
import CAddInformationNote from './header-options/add-activity-information-note-modal/main';
import ReactGA from 'react-ga4';
import ApiClient from '../../api/alms-api';
import { SecurityContextType, SecurityPermissionType } from '../../core/SecurityContext';

const T = Translator.create();
const _logger = Log.create('Header Options');
let _common: Common;
let displayCount = 0;
const AUTO_UPDATE_INTERVAL_SECONDS: number = 30;
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');

// ModuleTypes ve ActivityTypeEnums eşleme tablosu
const moduleTypeToActivityTypeEnum: { [key: number]: ActivityTypeEnums } = {
    1: ActivityTypeEnums.VirtualClass,
    2: ActivityTypeEnums.Survey,
    3: ActivityTypeEnums.Forum,
    6: ActivityTypeEnums.Assignment,
    7: ActivityTypeEnums.Elesson,
    8: ActivityTypeEnums.Exam,
    9: ActivityTypeEnums.Video,
    10: ActivityTypeEnums.Document,
    11: ActivityTypeEnums.TelegramActivity,
    170: ActivityTypeEnums.Dictionary,
    171: ActivityTypeEnums.LinkActivity,
    // 172: ActivityTypeEnums.LinkActivity, // Genel Link Aktivitesi
    173: ActivityTypeEnums.LTIActivity,
};
export class CHeaderOptionss extends React.Component<IHeaderOptions, any> {


    timerForNotificationListUpdate: number = 0;
    public activityModalRef: HTMLDivElement | null = null;
    public state = {
        selectedActivity: ActivityType.Other,
        updateActivityId: '',
        url: '',
        allowedActivities: [
            ActivityType.Assignment,
            ActivityType.Document,
            ActivityType.Forum,
            ActivityType.Video,
            ActivityType.VirtualClass,
            ActivityType.Exam,
            ActivityType.Elesson,
            ActivityType.Survey,
            ActivityType.LinkActivity,
            ActivityType.LTIActivity,
            ActivityType.InformationNote
        ],
        allowedProjectActivities: [
            ActivityType.Assignment,
            ActivityType.Document,
            ActivityType.Forum,
            ActivityType.Video,
            this.props.isGroupProject ? ActivityType.VirtualClass : null
        ],
        isOpenAddActivityModal: false,
        isOpenModalAdd: false,
        isDocumentModalOpen: false,
        isProjectModalOpen: false,
        isAssignmentModalOpen: false,
        isSurveyModalOpen: false,
        isElessonModalOpen: false,
        isVirtualClassModalOpen: false,
        isLinkModalOpen: false,
        isVideoModalOpen: false,
        isForumModalOpen: false,
        isExamModalOpen: false,
        isAnnouncementContentModalOpen: false,
        isLTIModalOpen: false,
        isInformationNoteModalOpen: false,
        modalHeaderData: '',
        isDisplayGrid: true,
        isDisplayList: false,
        usersAuthorizedToEdit: [UserType.Admin, UserType.ProgramAdmin, UserType.Teacher],
        branchLength: 0
    };

    constructor(props: any) {
        super(props);
        _apiClient = new ApiClient();
        _common = new Common();
        this.selectActivityOnClick = this.selectActivityOnClick.bind(this);
        this.onClickLogout = this.onClickLogout.bind(this);
        this.onClickGotoProfile = this.onClickGotoProfile.bind(this);
        this.addNewActivityModal = this.addNewActivityModal.bind(this);
        this.setCloseAddModal = this.setCloseAddModal.bind(this);
        this.setDisplaygrid = this.setDisplaygrid.bind(this);
        this.setDisplaylist = this.setDisplaylist.bind(this);
    }

    public headerState = (value: string) => {
        if (value) {
            this.setState({ modalHeaderData: value });
        }
    };

    triggerAnnouncementContentModal = () => {
        this.setState({
            ...this.state,
            isAnnouncementContentModalOpen: !this.state.isAnnouncementContentModalOpen
        });
    };

    public onAnnouncementClick(announcementId: string) {
        const announcementIndex = this.props.announcements.findIndex(item => item.announcementId === announcementId);
        this.props.dispatch(AnnouncementAction.GetLoginAnnouncementById(announcementId, 'getLoginAnnouncement', 'get', announcementIndex));
        this.triggerAnnouncementContentModal();
    }

    public onClickChangeAnnouncement = () => {
        const announcements = this.props.announcements.filter(item => item.showOnStartup && !item.isRead);
        if (announcements && announcements.length) {
            const nextItem = this.props.announcements.find(item => item.announcementId === announcements[0].announcementId);
            if (nextItem) {
                // dispatch bir sonraki announcement
                const announcementIndex = this.props.announcements.findIndex(item => item.announcementId === nextItem.announcementId);
                this.props.dispatch(
                    AnnouncementAction.GetLoginAnnouncementById(nextItem.announcementId!, 'getLoginAnnouncement', 'get', announcementIndex)
                );
            }
        } else {
            // close modal
            this.triggerAnnouncementContentModal();
        }
    };

    public onClickLogout() {
        // TODO: temizle ve yonlendir logine
        this.props.dispatch(ProfileAction.setProfileAction(null, "setProfileAction", "set"))
        _common.ClearAuthLocalStorage();
        this.props.dispatch(Actions.logOff());
        this.props.history.push(window.appSettings.DEFAULT_URL);
    }

    public toAlms = () => {
        const token: any = localStorage.getItem('access_token');
        const url: string = window.appSettings.ALMS_URL + '/Account/SSO_Alms?token=' + token;
        window.open(url, '_blank');
    };

    public onClickGotoProfile() {
        this.props.history.push(window.appSettings.DEFAULT_URL + '/u/profile');
    }

    public refreshActivityCards = async (value: any) => {
        await this.getData(value).then(() => {
            setTimeout(() => {
                this.props.dispatch(CourseActions.SetActivityIdAfterAdd(value.activityId));
            }, 1000);
        });
    };

    getData = async (value: any) => {
        // if (value.isUpdateWeeks) {
        //     this.props.dispatch(CourseActions.getCourseContentMenu(this.props.coursePageClassId, value.termWeekId, false, 'getCourseContentMenu', 'get'));
        // }

        if (this.props.courseContentTermWeeks !== undefined) {
            this.props.dispatch(
                CourseActions.SetTriggerWeekOnClick(
                    '',
                    value.termWeekId,
                    CourseContentMenuType.weekAndActivityStory,
                    '',
                    this.props.courseContentTermWeeks,
                    false,
                    this.props.coursePageClassId!,
                    this.props.coursePageActivityId!,
                    this.props.sortKey ?? '-',
                    this.props.activityFilters,
                    [],
                    this.props.courseDefaultView,
                    this.callbackTriggerWeekOnClick,
                    'adding-spinner'
                )
            );
            this.props.courseContentTermWeeks.forEach(item => {
                if (item.termWeekId !== value.termWeekId) {
                    $('#collapse' + item.itemGuid).removeClass('show');
                }
            });
        }

        const url =
            window.appSettings.DEFAULT_URL +
            '/u/course?classId=' +
            this.props.coursePageClassId +
            '&activityId=' +
            this.props.coursePageActivityId +
            '&type=1&actid=' +
            value.activityId +
            '&weekorunitid=' +
            value.termWeekId;
        this.props.history.push(url);
    };

    callbackTriggerWeekOnClick() { }

    public selectActivityOnClick = (event?: any, activityType?: any) => {
        if (activityType) {
            this.state.updateActivityId = this.props.activityId ? this.props.activityId : '';
        } else {
            this.state.updateActivityId = '';
        }
        switch (activityType ? activityType : event.currentTarget.dataset.activitytype) {
            case ActivityType.Document: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isDocumentModalOpen: !this.state.isDocumentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.Reading: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isDocumentModalOpen: !this.state.isDocumentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.Project: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isProjectModalOpen: !this.state.isProjectModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.Assignment: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isAssignmentModalOpen: !this.state.isAssignmentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.Survey: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isSurveyModalOpen: !this.state.isSurveyModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.Elesson: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isElessonModalOpen: !this.state.isElessonModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.VirtualClass: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isVirtualClassModalOpen: !this.state.isVirtualClassModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.LinkActivity: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isLinkModalOpen: !this.state.isLinkModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.Video: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isVideoModalOpen: !this.state.isVideoModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.Forum: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isForumModalOpen: !this.state.isForumModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.Exam: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isExamModalOpen: !this.state.isExamModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.LTIActivity: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isLTIModalOpen: !this.state.isLTIModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            case ActivityType.InformationNote: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isInformationNoteModalOpen: !this.state.isInformationNoteModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
            default: {
                this.setState({
                    ...this.state,
                    selectedActivity: activityType ? activityType : event.currentTarget.dataset.activitytype,
                    isAssignmentModalOpen: !this.state.isAssignmentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal,
                    isOpenModalAdd: false
                });
                break;
            }
        }
    };

    public onClose = (activityType: any) => {
        switch (activityType) {
            case ActivityType.Document: {
                this.setState({
                    isDocumentModalOpen: !this.state.isDocumentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Reading: {
                this.setState({
                    isDocumentModalOpen: !this.state.isDocumentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Project: {
                this.setState({
                    isProjectModalOpen: !this.state.isProjectModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Assignment: {
                this.setState({
                    isAssignmentModalOpen: !this.state.isAssignmentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Survey: {
                this.setState({
                    isSurveyModalOpen: !this.state.isSurveyModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Elesson: {
                this.setState({
                    isElessonModalOpen: !this.state.isElessonModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.VirtualClass: {
                this.setState({
                    isVirtualClassModalOpen: !this.state.isVirtualClassModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.LinkActivity: {
                this.setState({
                    isLinkModalOpen: !this.state.isLinkModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Video: {
                this.setState({
                    isVideoModalOpen: !this.state.isVideoModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Forum: {
                this.setState({
                    isForumModalOpen: !this.state.isForumModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.Exam: {
                this.setState({
                    isExamModalOpen: !this.state.isExamModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.LTIActivity: {
                this.setState({
                    isLTIModalOpen: !this.state.isLTIModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            case ActivityType.InformationNote: {
                this.setState({
                    isInformationNoteModalOpen: !this.state.isInformationNoteModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
            default: {
                this.setState({
                    isAssignmentModalOpen: !this.state.isAssignmentModalOpen,
                    isOpenAddActivityModal: !this.state.isOpenAddActivityModal
                });
                break;
            }
        }
    };

    public setCloseModal = (activityType: ActivityType) => {
        const addActivityModal = document.getElementsByClassName('add-activity-modal');
        if (addActivityModal && addActivityModal[0] && addActivityModal[0].classList) {
            addActivityModal[0].classList.remove('slideInRight');
            addActivityModal[0].classList.add('slideOutRight');
        }
        setTimeout(() => {
            this.onClose(activityType);
        }, 300);
    };

    public onCompleteValidateForm = (validations: any, projectActivityValidations?: string[], isProjectSubActivity?: boolean) => {
        let isValidate: boolean = true;

        if (isProjectSubActivity) {
            Object.keys(validations).forEach((validationKey: string) => {
                if (projectActivityValidations!.find(key => key === validationKey)) {
                    Notification.setNotification(
                        'error',
                        T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                        'topRight'
                    );

                    isValidate = false;
                }
            });
        } else {
            Object.keys(validations).forEach((validationKey: string) => {
                Notification.setNotification(
                    'error',
                    T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                    'topRight'
                );

                isValidate = false;
            });
        }

        return isValidate;
    };

    public setModalActivity = (type: ActivityType) => {
        let isSingleClass = false;
        let hasClass = false;
        if (this.props.classes) {
            if (
                this.state.branchLength <= 1 &&
                this.props.userType != UserType.Admin &&
                this.props.userType != UserType.ProgramAdmin &&
                !Common.HasPermission(SecurityContextType.Course, SecurityPermissionType.Activity_Add, this.props.coursePageActivityId)
            ) {
                isSingleClass = true;
            }
            if (this.state.branchLength > 0) {
                hasClass = true;
            }
        }

        switch (type) {
            case ActivityType.Document:
            case ActivityType.Reading: {
                return (
                    <CAddDocument
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isDocumentModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        activityCard={this.props.activityCard}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.Project: {
                return (
                    <CAddProject
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isProjectModalOpen}
                        setCloseModal={this.setCloseModal}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.Assignment: {
                return (
                    <CAddAssignment
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isAssignmentModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        activityCard={this.props.activityCard}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.Survey: {
                return (
                    <CAddSurvey
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isSurveyModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        updateActivityIdFunction={this.updateActivityIdFunction}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.Elesson: {
                return (
                    <CAddElesson
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isElessonModalOpen}
                        setCloseModal={this.setCloseModal}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        activityCard={this.props.activityCard}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.VirtualClass: {
                return (
                    <CAddVirtualClass
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isVirtualClassModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.LinkActivity: {
                return (
                    <CAddLink
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isLinkModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }

            case ActivityType.Video: {
                return (
                    <CAddVideo
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isVideoModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                    />
                );
            }

            case ActivityType.Forum: {
                return (
                    <CAddForum
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isForumModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.Exam: {
                return (
                    <CAddExam
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isExamModalOpen}
                        setCloseModal={this.setCloseModal}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        updateActivityIdFunction={this.updateActivityIdFunction}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.LTIActivity: {
                return (
                    <CAddLTI
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isLTIModalOpen}
                        setCloseModal={this.setCloseModal}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            case ActivityType.InformationNote: {
                return (
                    <CAddInformationNote
                        onRefreshActivityCards={this.refreshActivityCards}
                        updateActivityId={this.state.updateActivityId}
                        onClose={this.onClose}
                        isModalOpen={this.state.isInformationNoteModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        activityCard={this.props.activityCard}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
            default: {
                return (
                    <CAddAssignment
                        onRefreshActivityCards={this.refreshActivityCards}
                        onClose={this.onClose}
                        isModalOpen={this.state.isAssignmentModalOpen}
                        setCloseModal={this.setCloseModal}
                        isProjectSubActivity={this.props.isProjectActivity}
                        projectActivityId={this.props.projectActivityId}
                        onCompleteValidateForm={this.onCompleteValidateForm}
                        isSingleClass={isSingleClass}
                        hasClass={hasClass}
                    />
                );
            }
        }
    };

    public componentDidMount() {
        this.getOptions();
        this.filterAllowedActivities();
    }

    public getOptions = async () => {
        let requestModel = {
            CourseId: this.props.coursePageActivityId,
            SearchedText: '',
            Skip: 0,
            Take: 9999
        };
        const returnApi = await _apiClient
            .RequestAsync('post', 'api/class/classes', requestModel, token, false, 0)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                }
                return responseData.json();
            })
            .then((result: any) => {
                let options = [];
                if (result != null && result.length > 0) {
                    const checkResult = result;
                    options = checkResult;
                    this.props.dispatch(CourseActions.setCourseClasses(this.props.coursePageActivityId, options));
                    this.setState({ branchLength: result.length });
                }
                return options;
            })
            .catch(response => {
                return [];
            });

        return returnApi;
    };
    getNotifications = (isOnlyCount: boolean) => {
        this.props.dispatch(NotificationPageAction.GetNotifications(isOnlyCount));
    };

    public componentWillUnmount() {
        window.clearInterval(this.timerForNotificationListUpdate);
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.coursePageClassId !== this.props.coursePageClassId) {
            this.getOptions();
        }
        if (prevProps.announcements !== this.props.announcements && displayCount === 0) {
            const announcements = this.props.announcements.filter(item => item.showOnStartup && !item.isRead);
            if (announcements && announcements.length > 0) {
                displayCount++;
                this.onAnnouncementClick(announcements[0].announcementId!);
            }
        }
        if (prevProps.moduleItems !== this.props.moduleItems) {
            this.filterAllowedActivities();
        }
    }

    // moduleItem'ı ActivityType string'ine dönüştüren yardımcı fonksiyon
    private mapModuleItemToActivityType = (moduleItem: number): ActivityType | null => {
        switch (moduleItem) {
            case ActivityTypeEnums.Assignment:
                return ActivityType.Assignment;
            case ActivityTypeEnums.Course:
                return ActivityType.Course;
            case ActivityTypeEnums.Elesson:
                return ActivityType.Elesson;
            case ActivityTypeEnums.Exam:
                return ActivityType.Exam;
            case ActivityTypeEnums.Forum:
                return ActivityType.Forum;
            case ActivityTypeEnums.Document:
                return ActivityType.Document;
            case ActivityTypeEnums.VirtualClass:
                return ActivityType.VirtualClass;
            case ActivityTypeEnums.Survey:
                return ActivityType.Survey;
            case ActivityTypeEnums.Video:
                return ActivityType.Video;
            case ActivityTypeEnums.LinkActivity:
                return ActivityType.LinkActivity;
            case ActivityTypeEnums.LTIActivity:
                return ActivityType.LTIActivity;
            case ActivityTypeEnums.InformationNote:
                return ActivityType.InformationNote;
            // Diğer ActivityTypeEnums değerleri için case ekleyin
            default:
                return null;
        }
    };
    // AllowedActivities listesini filtreleyen fonksiyon
    private filterAllowedActivities() {
        const { moduleItems } = this.props;

        const filteredActivities = moduleItems
            .map((moduleItem: number) => {
                const activityTypeEnum = moduleTypeToActivityTypeEnum[moduleItem];
                return activityTypeEnum ? this.mapModuleItemToActivityType(activityTypeEnum) : null;
            })
            .filter((activity: ActivityType | null): activity is ActivityType =>
                activity !== null &&
                this.state.allowedActivities.includes(activity)&&
                (activity !== ActivityType.Survey || Common.HasPermission(SecurityContextType.Course, SecurityPermissionType.Activity_Survey_View, this.props.coursePageActivityId))
            );

        // InformationNote her zaman eklensin
        if (!filteredActivities.includes(ActivityType.InformationNote)) {
            filteredActivities.push(ActivityType.InformationNote);
        }

        this.setState({ allowedActivities: filteredActivities as ActivityType[] });
    }


    public ConnectToAlms() {
        this.props.dispatch(Actions.connectToAlms('LoadingMain', 'get'));
    }

    public clickToDownload = (message: string) => {
        const messageSplit = message.split('-FileDownloadLink:');
        let linkUrl: string = window.appSettings.API_URL;

        if (messageSplit.length > 1) {
            const filePath = messageSplit[1];
            if (filePath.startsWith('https:')) {
                linkUrl = filePath;
                _common.DownloadLink(linkUrl, '');
            } else if (filePath.startsWith('zip:')) {
                let zipurl = filePath.replace('zip:', '');
                linkUrl += '/' + zipurl;
                _common.DownloadZip(linkUrl, T.t('r_assignment_files'));
            } else {
                if (filePath.startsWith('/')) {
                    linkUrl += filePath;
                } else {
                    linkUrl += '/' + filePath;
                }
                _common.DownloadLink(linkUrl, '');
            }
        }
    };

    public clickTopNotification = (markAsRead: boolean) => {
        if (markAsRead) {
            this.props.dispatch(NotificationPageAction.GetReadNotifications());
        }
    };

    public updateActivityIdFunction = (activityId: string) => {
        this.setState({ updateActivityId: activityId });
    };

    public changeLanguage = () => {
        let changeCulture = '';
        if (this.props.culture) {
            changeCulture = this.props.culture === 'en-US' ? 'tr-TR' : 'en-US';
        } else {
            if (this.props.defaultCulture) {
                changeCulture = this.props.defaultCulture === 'en-US' ? 'tr-TR' : 'en-US';
            } else {
                changeCulture = 'en-US';
            }
        }
        if (changeCulture) {
            this.props.dispatch(ProfileAction.getChangeLanguageAction(changeCulture));
        }
    };
    public goFeedbackPage() {
        window.open(
            'https://docs.google.com/forms/d/e/1FAIpQLSdi5YZ6U1u_wCRsfNw6upEn0MII7bryEBuaO3YhNo7yGVDvpw/viewform?entry.2056386244=' +
            this.props.identity.firstName +
            '&entry.1209909801=' +
            this.props.identity.lastName +
            '&entry.1990079686=' +
            this.props.login.organizationName +
            '&entry.251353563=' +
            this.props.identity.email
        );
    }

    public addNewActivityModal() {
        ReactGA.event({
            category: window.location.host,
            action: 'G_LEFT_ADD_ACTIVITY_CLICKED',
            label: 'G_LEFT_ADD_ACTIVITY_CLICKED',
            nonInteraction: true
        });
        this.setState({ isOpenModalAdd: true });
    }
    public setCloseAddModal() {
        this.setState({ isOpenModalAdd: false });
    }
    public setDisplaygrid() {
        this.setState({ isDisplayGrid: true });
        this.setState({ isDisplayList: false });
    }

    public setDisplaylist() {
        this.setState({ isDisplayGrid: false });
        this.setState({ isDisplayList: true });
    }

    viewActivityTypeIcon = (activity: any) => {
        if (activity) {
            return _common.GetActivityTypeIcons(activity);
        } else {
            return '';
        }
    };

    viewDisplayIcon = (value: boolean) => {
        if (value === true) {
            return 'active-icons';
        } else {
            return '';
        }
    };
    public render() {

        const { history } = this.props;
        history.listen((location: any, action: any) => {
            // location is an object like window.location
            if (action === 'PUSH') {
                this.setState({
                    url: location.pathname.toString()
                });
            }
        });

        // // if edit button clicked from activity card
        if (this.props.activityType) {
            const event: any = null;
            this.selectActivityOnClick(event, this.props.activityType);
            this.props.dispatch(Action.activityTypeSetAction(null, null));
        }
        const notifications = this.props.notifications;





        return (
            <div style={{ marginLeft: 'auto', marginRight: '8px' }}>
                <div className="header-options">
                    <BaseModal
                        minWidth={1100}
                        modalIsOpen={this.state.isAnnouncementContentModalOpen}
                        onClose={this.triggerAnnouncementContentModal}
                        headerState={this.state.modalHeaderData}
                        backdrop={'static'}
                        headerIcon={'clock'}
                        showHeader={true}
                    >
                        <LoginAnnouncementModal
                            leftAnnouncementCount={this.props.announcements.filter(item => item.showOnStartup && !item.isRead).length}
                            onClickChangeAnnouncement={this.onClickChangeAnnouncement}
                            headerState={this.headerState}
                        />
                    </BaseModal>
                    <div className="plus-dropdown sidebar-plus">
                        <div className="dropdown position-static" tabIndex={0}>
                            <button
                                tabIndex={-1}
                                onClick={this.addNewActivityModal}
                                className="success-btn d-block   m-0"
                                style={{ padding: '6px', fontSize: '10px', borderRadius: '50%' }}
                            >
                                <i className="material-icons d-block" tabIndex={0}>
                                    add
                                </i>
                                {/* {T.t('r_gen_add_activity')} */}
                            </button>
                            <Modal
                                isOpen={this.state.isOpenModalAdd}
                                toggle={this.setCloseAddModal}
                                modalClassName={'add-activity-modal modal-from-right slideInRight show animated'}
                                fade={true}
                                style={{ display: 'block', animationDuration: '0.5s' }}
                                backdrop={'static'}
                                id={'add_new_activity'}
                            >
                                <div className="modal-dialog" role="document" style={{ width: '45vw' }}>
                                    <div className="modal-content">
                                        <div className="modal-header d-flex justify-content-start">
                                            <h5 className="modal-title d-flex align-items-center">{T.t('r_gen_add_activity')}</h5>
                                            <button
                                                onClick={this.setCloseAddModal}
                                                type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <i style={{ color: '#000' }} className="material-icons">
                                                    close
                                                </i>
                                                <span>{T.t('r_gen_close')}</span>
                                            </button>
                                        </div>
                                        <div className="add_activity_modal_body modal-body p-3">
                                            <div className="header">
                                                <span>{T.t('r_gen_filter_activityType_2')}</span>
                                                <div className="add_activity_toggle">
                                                    <a
                                                        onMouseDown={this.setDisplaygrid}
                                                        id="active_grid"
                                                        className={this.viewDisplayIcon(this.state.isDisplayGrid)}
                                                    >
                                                        <img src={_common.GetDefaultIcons('displaygrid')} alt="" />
                                                    </a>
                                                    <a
                                                        onMouseDown={this.setDisplaylist}
                                                        id="active_list"
                                                        className={this.viewDisplayIcon(this.state.isDisplayList)}
                                                    >
                                                        <img src={_common.GetDefaultIcons('displaylist')} alt="" />
                                                    </a>
                                                </div>
                                            </div>
                                            {this.state.isDisplayGrid ? (
                                                <div id="grid" className="row">
                                                    {this.props.isProjectActivity
                                                        ? this.state.allowedProjectActivities
                                                            .filter(activity => activity)
                                                            .map((activity, index) => (
                                                                <div className="col-3" key={index}>
                                                                    <div className="add_activity_list_btn">
                                                                        <a
                                                                            data-activitytype={activity}
                                                                            onClick={this.selectActivityOnClick}
                                                                        >
                                                                            <img
                                                                                className="mx-2"
                                                                                style={{ width: '24px', height: 'auto' }}
                                                                                src={this.viewActivityTypeIcon(activity)}
                                                                                alt="Link Activity Icon"
                                                                            />
                                                                            <span>{T.t('r_gen_enum_activity_' + activity)}</span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        : this.state.allowedActivities.map((activity, index) => {

                                                            return (
                                                                <div className="col-3 mt-2" key={index}>
                                                                    <div className="add_activity_list_btn_grid">
                                                                        <a
                                                                            className="activity_grid_item"
                                                                            data-activitytype={activity}
                                                                            onClick={this.selectActivityOnClick}
                                                                        >
                                                                            <img
                                                                                className="mx-2"
                                                                                style={{ width: '24px', height: '24px' }}
                                                                                src={_common.GetActivityTypeIcons(activity)}
                                                                                alt={'Activity Icon'}
                                                                            />
                                                                            <span>{T.t('r_gen_enum_activity_' + activity)}</span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    <div className="col-12 mb-3 mt-4 activity_explain_text">
                                                        <span>{T.t('r_gen_activity_explain')}</span>
                                                    </div>
                                                    {this.state.allowedActivities.map((activity, index) => (
                                                        <div className="col-12 mt-2 mb-3" key={index}>
                                                            <div
                                                                className={'add_activity_list_btn '.concat(activity.toLowerCase())}
                                                            >
                                                                <a
                                                                    className="d-flex justify-content-start align-items-center"
                                                                    data-activitytype={activity}
                                                                >
                                                                    <img
                                                                        className="ml-2 mr-3"
                                                                        style={{ width: '20px', height: '20px' }}
                                                                        src={_common.GetDefaultIcons('info')}
                                                                        alt={'Activity Icon'}
                                                                    />
                                                                    <div className="d-flex flex-column justify-content-start ">
                                                                        <span className="activity_explain_text">
                                                                            {T.t('r_gen_enum_activity_' + activity)}
                                                                        </span>
                                                                        <span className="activity_explain">
                                                                            {T.t('r_gen_enum_activity_exp_' + activity)}
                                                                        </span>
                                                                    </div>
                                                                </a>
                                                                {/*derste bulunan aktivite sayısı */}
                                                                {/* <span className='activity_size'>-</span> */}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div id="list" className="row">
                                                    {this.props.isProjectActivity
                                                        ? this.state.allowedProjectActivities
                                                            .filter(activity => activity)
                                                            .map((activity, index) => (
                                                                <div className="col-6" key={index}>
                                                                    <div className="add_activity_list_btn">
                                                                        <a
                                                                            data-activitytype={activity}
                                                                            onClick={this.selectActivityOnClick}
                                                                        >
                                                                            <img
                                                                                className="mx-2"
                                                                                style={{ width: '24px', height: 'auto' }}
                                                                                src={this.viewActivityTypeIcon(activity)}
                                                                                alt="Link Activity Icon"
                                                                            />
                                                                            <span>{T.t('r_gen_enum_activity_' + activity)}</span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        : this.state.allowedActivities.map((activity, index) => (
                                                            <div className="col-6 mt-2" key={index}>
                                                                <div
                                                                    className={'add_activity_list_btn '.concat(
                                                                        activity.toLowerCase()
                                                                    )}
                                                                >
                                                                    <a
                                                                        data-activitytype={activity}
                                                                        onClick={this.selectActivityOnClick}
                                                                    >
                                                                        <img
                                                                            className="mx-2"
                                                                            style={{ width: '24px', height: '24px' }}
                                                                            src={_common.GetActivityTypeIcons(activity)}
                                                                            alt={'Activity Icon'}
                                                                        />
                                                                        <span>{T.t('r_gen_enum_activity_' + activity)}</span>
                                                                    </a>
                                                                    {/*derste bulunan aktivite sayısı */}
                                                                    {/* <span className='activity_size'>-</span> */}
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </div>

                        {this.state.isOpenAddActivityModal && this.state.selectedActivity ? (
                            <div ref={e => (this.activityModalRef = e)} className="" style={{ display: 'block' }}>
                                {this.setModalActivity(this.state.selectedActivity)}
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHeaderOptions): IHeaderOptions => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHeaderOptions = Object.assign({}, ownProps, {
        activityType: state.mainMenuRoot.activityAddType,
        activityId: state.mainMenuRoot.activityAddId,
        userType: state.login.identitiy.userType,
        moduleItems: state.login.login.moduleItems,
        profileImagePath: state.login.identitiy.profileImagePath,
        photoKey: state.profile.photoKey,
        fullName: state.login.identitiy.fullName,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        announcements: state.announcement.homePageAnnouncements,
        notifications: state.notification.notifications,
        unreadNotificationCount: state.notification.unreadNotificationCount,
        isShowActivityAdd: state.coursePage.isShowActivityAdd,
        culture: state.login.identitiy.culture,
        defaultCulture: state.login.login.defaultCulture,
        classes: state.coursePage.classes,
        identity: state.login.identitiy,
        login: state.login.login,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        courseDefaultView: state.coursePage.courseDefaultView,
        sortKey: state.coursePage.courseSortingKey,
        activityFilters: state.coursePage.activityFilters
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.announcement.homePageAnnouncements === prev.announcement.homePageAnnouncements &&
        next.mainMenuRoot.activityAddType === prev.mainMenuRoot.activityAddType &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.notification.notifications === prev.notification.notifications &&
        next.notification.unreadNotificationCount === prev.notification.unreadNotificationCount &&
        next.coursePage.isShowActivityAdd === prev.coursePage.isShowActivityAdd &&
        next.login.identitiy.culture === prev.login.identitiy.culture &&
        next.coursePage.classes === prev.coursePage.classes &&
        next.login.identitiy === prev.login.identitiy &&
        next.login.login === prev.login.login &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const HeaderOptionss = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CHeaderOptionss);

export default withRouter<any, any>(HeaderOptionss);
